import { useExecuteOneTime } from '@/shared/hooks/useExecuteOneTime';
import { PricingEntryPoint } from '@/shared/lib/pricingAttribution';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';
import { PaywallCardLayout } from '@/shared/ui/PaywallCard';

import { ONSCREEN_PAYWALL_VARIANT, useOnscreenPaywallCta } from '../../model/useOnscreenPaywallCta';
import { OnscreenPaywallView } from './OnscreenPaywallView';

type OnscreenPaywallProps = {
  layout: PaywallCardLayout;
  pricingEntryPoint: PricingEntryPoint;
  // Set when the paywall is a modal: its close button, and the paywall closes on its CTA.
  onClose?: () => void;
  onLeaveForPricing?: () => void;
};

// Offers on-screen text translation to a plan without it, as a modal or as the Visual tab's card.
export const OnscreenPaywall = ({ layout, pricingEntryPoint, onClose, onLeaveForPricing }: OnscreenPaywallProps) => {
  const { offer, onCta } = useOnscreenPaywallCta({ pricingEntryPoint, onLeave: onClose, onLeaveForPricing });

  useExecuteOneTime(() =>
    MixpanelEvents.paywallOpened({ paywall_variant: ONSCREEN_PAYWALL_VARIANT, pricing_entry_point: pricingEntryPoint }),
  );

  return <OnscreenPaywallView layout={layout} offer={offer} onClose={onClose} onCta={onCta} />;
};
